<template>
  <div class="arrow" :class="{ 'short': $vuetify.breakpoint.smAndDown, reverse }">
    <!-- NB: not a very Vue way to do this, but there's a problem with assets compulation that I don't want to figure out right now -->
    <img :class="{ 'hidden': !$vuetify.breakpoint.smAndDown }" src="../assets/images/arrow-short.svg" alt="arrow"/>
    <img :class="{ 'hidden': $vuetify.breakpoint.smAndDown }" src="../assets/images/arrow.svg" alt="arrow"/>
  </div>
</template>

<script>
export default {
  name: 'arrow',
  props: {
    reverse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  }
}
</script>
<style lang="stylus">
@require '~vuetify/src/stylus/settings/_variables.styl'

.arrow
  width 68px
  display inline-flex !important
  align-self flex-start
  flex-grow 0 !important
  flex-shrink 0 !important

  > img
    display flex
    align-self center

  &.short
    width 40px

  &.reverse
    transform rotate(180deg)

  .hidden
    display none

  .full-content-link &
    position relative
    top 4px
    @media $display-breakpoints.sm-and-down
      top 0
</style>
